export default{
    bank: {
        index: 'bank-index',
    }
}
